import React from 'react';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';

const GroupedCell = ({ cell, row }) => (
  <div {...row.getToggleRowExpandedProps()}>
    <span>
      <ArrowRightIcon viewBox="0 0 16 18" style={{ width: 15, height: 15 }} />
    </span>{' '}
    {cell.render('Cell')} ({row.subRows.length})
  </div>
);

export default GroupedCell;
